import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap';


class ButtonsAdminToevoegen extends Component {
    render() {
        return (
            <div>
                <Row>
                    <Col md={4} sm={4}>
                        <div>
                            <LinkContainer to={"/adminmember/kennis/bijeenkomst/toevoegen/" + this.props.id}><Button bsSize="large" block>Bijeenkomst</Button></LinkContainer>
                            <LinkContainer to={"/adminmember/kennis/cursus/toevoegen/" + this.props.id}><Button bsSize="large" block>Cursus</Button></LinkContainer>
                            <LinkContainer to={"/adminmember/kennis/docentschap/kiezen/" + this.props.id}><Button bsSize="large" block>Docentschap</Button></LinkContainer>
                        </div>
                    </Col>
                    <Col md={4} sm={4}>
                        <div>
                            <LinkContainer to={"/adminmember/kennis/incompany-cursus/toevoegen/" + this.props.id}><Button bsSize="large" block>Incompany cursus</Button></LinkContainer>
                            <LinkContainer to={"/adminmember/kennis/incompany-kennisoverdracht/toevoegen/" + this.props.id}><Button bsSize="large" block>Incompany kennisoverdracht</Button></LinkContainer>
                            <LinkContainer to={"/adminmember/kennis/lidmaatschap/kiezen/" + this.props.id}><Button bsSize="large" block>Lidmaatschap</Button></LinkContainer>
                        </div>
                    </Col>
                    <Col md={4} sm={4}>
                        <div>
                            <LinkContainer to={"/adminmember/kennis/opleiding/toevoegen/" + this.props.id}><Button bsSize="large" block>Opleidingen</Button></LinkContainer>
                            <LinkContainer to={"/adminmember/kennis/publicaties/toevoegen/" + this.props.id}><Button bsSize="large" block>Publicatie</Button></LinkContainer>
                            <LinkContainer to={"/adminmember/kennis/voordracht/toevoegen/" + this.props.id}><Button bsSize="large" block>Voordracht</Button></LinkContainer>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ButtonsAdminToevoegen;



// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/AddButtonsadmin.js